import { render, staticRenderFns } from "./pedidopwa.vue?vue&type=template&id=6b5eace2"
import script from "./pedidopwa.vue?vue&type=script&lang=js"
export * from "./pedidopwa.vue?vue&type=script&lang=js"
import style0 from "./pedidopwa.vue?vue&type=style&index=0&id=6b5eace2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports